import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './auth-guard.service';

const routes: Routes = [
  { path: '', redirectTo: 'landing', pathMatch: 'full' },
  {
    path: 'home',
    loadChildren: () =>
      import('./home/home.module').then((m) => m.HomePageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'login',
    loadChildren: () =>
      import('./login/login.module').then((m) => m.LoginPageModule),
  },
  {
    path: 'register',
    loadChildren: () =>
      import('./register/register.module').then((m) => m.RegisterPageModule),
  },
  {
    path: 'signup',
    loadChildren: () =>
      import('./signup/signup.module').then((m) => m.SignupPageModule),
  },
  {
    path: 'profile',
    loadChildren: () =>
      import('./profile/profile.module').then((m) => m.ProfilePageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'history',
    loadChildren: () =>
      import('./history/history.module').then((m) => m.HistoryPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'message',
    loadChildren: () =>
      import('./message/message.module').then((m) => m.MessagePageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'aboutus',
    loadChildren: () =>
      import('./about-us/about-us.module').then((m) => m.AboutUsPageModule),
  },
  {
    path: 'term_cond',
    loadChildren: () =>
      import('./terms/terms.module').then((m) => m.TermsPageModule),
  },
  {
    path: 'privacy',
    loadChildren: () =>
      import('./privacy/privacy.module').then((m) => m.PrivacyPageModule),
  },
  {
    path: 'news',
    loadChildren: () =>
      import('./news/news.module').then((m) => m.NewsPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'wallet',
    loadChildren: () =>
      import('./wallet/wallet.module').then((m) => m.WalletPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'add-token-to-wallet',
    loadChildren: () =>
      import('./add-token-to-wallet/add-token-to-wallet.module').then(
        (m) => m.AddTokenToWalletPageModule,
      ),
  },
  {
    path: 'confirm-payment',
    loadChildren: () =>
      import('./confirm-payment/confirm-payment.module').then(
        (m) => m.ConfirmPaymentPageModule,
      ),
  },
  {
    path: 'success-topup',
    loadChildren: () =>
      import('./success-topup/success-topup.module').then(
        (m) => m.SuccessTopupPageModule,
      ),
    // canActivate: [AuthGuard],
  },
  {
    path: 'unsuccess-topup',
    loadChildren: () =>
      import('./unsuccess-topup/unsuccess-topup.module').then(
        (m) => m.UnsuccessTopupPageModule,
      ),
    // canActivate: [AuthGuard],
  },
  {
    path: 'machine-details',
    loadChildren: () =>
      import('./machine-details/machine-details.module').then(
        (m) => m.MachineDetailsPageModule,
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'machine-success',
    loadChildren: () =>
      import('./machine-success/machine-success.module').then(
        (m) => m.MachineSuccessPageModule,
      ),
  },
  {
    path: 'machine-failure',
    loadChildren: () =>
      import('./machine-failure/machine-failure.module').then(
        (m) => m.MachineFailurePageModule,
      ),
  },
  {
    path: 'refund',
    loadChildren: () =>
      import('./refund/refund.module').then((m) => m.RefundPageModule),
    canActivate: [AuthGuard],
  },

  {
    path: 'forget-password',
    loadChildren: () =>
      import('./forget-password/forget-password.module').then(
        (m) => m.ForgetPasswordPageModule,
      ),
  },
  {
    path: 'scan',
    loadChildren: () =>
      import('./scan/scan.module').then((m) => m.ScanPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'prompt-email',
    loadChildren: () =>
      import('./prompt-email/prompt-email.module').then(
        (m) => m.PromptEmailPageModule,
      ),
  },
  {
    path: 'email-verification',
    loadChildren: () =>
      import('./email-verification/email-verification.module').then(
        (m) => m.EmailVerificationPageModule,
      ),
  },
  {
    path: 'topup-qr',
    loadChildren: () =>
      import('./topup-qr/topup-qr.module').then((m) => m.TopupQrPageModule),
  },
  // {
  //   path: 'topup-timeout',
  //   loadChildren: () =>
  //     import('./topup-timeout/topup-timeout.module').then(
  //       (m) => m.TopupTimeoutPageModule,
  //     ),
  // },
  {
    path: 'machine-timeout',
    loadChildren: () =>
      import('./machine-timeout/machine-timeout.module').then(
        (m) => m.MachineTimeoutPageModule,
      ),
  },
  {
    path: 'redeem',
    loadChildren: () =>
      import('./redeem/redeem.module').then((m) => m.RedeemPageModule),
  },
  {
    path: 'delete-account',
    loadChildren: () =>
      import('./delete-account/delete-account.module').then(
        (m) => m.DeleteAccountPageModule,
      ),
  },
  {
    path: 'landing',
    loadChildren: () =>
      import('./landing/landing.module').then((m) => m.LandingPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'all-news',
    loadChildren: () =>
      import('./all-news/all-news.module').then((m) => m.AllNewsPageModule),
  },
  {
    path: 'top-up-pending',
    loadChildren: () =>
      import('./top-up-pending/top-up-pending.module').then(
        (m) => m.TopUpPendingPageModule,
      ),
  },
  {
    path: 'login-verification',
    loadChildren: () =>
      import('./login-verification/login-verification.module').then(
        (m) => m.LoginVerificationPageModule,
      ),
  },
  {
    path: 'redeem-wallet-balance',
    loadChildren: () =>
      import('./redeem-wallet-balance/redeem-wallet-balance.module').then(
        (m) => m.RedeemWalletBalancePageModule,
      ),
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: PreloadAllModules,
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
